import React, { useEffect, useState } from "react";
import "./App.css";
import LoginPage from "./components/LoginPage/LoginPage.js";
import ResetPassword from "./components/LoginPage/ResetPassword.js";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Sidebar from "./components/SideBar/Sidebar.jsx";
import Dashboard from "./pages/DashBaord/Dashboard.jsx";
import SubAdminList from "./pages/Accounts/SubAdmin/List.js";
import SubAdminAddEditData from "./pages/Accounts/SubAdmin/AddEditData.js";
import { fetchIpAddress } from "./controllers/API";
import { decryptData } from "./controllers/Encryption.js";

import { PermissionProvider } from "./controllers/PermissionContext.js";

////////////////////////////////////////////////////////////////////////////////////////

import UsersList from "./pages/v1/users/List.js";
import B2BUserList from "./pages/v1/users/B2BUserList.js";
import B2CUserList from "./pages/v1/users/B2CUserList.js";
import PromocodeList from "./pages/v1/promocodes/List.js";
import UsersAddEdit from "./pages/v1/users/AddEditData.js";
import PromocodeOrder from "./pages/v1/promocodes/Order.js";
import BPointList from "./pages/v1/recharge/points/List.js";
import PromocodeEditPage from "./pages/v1/promocodes/AddEditData.js";

import PromoCodeVoucher from "./pages/v1/promocodes/vouchers/List.js";

import ProductList from "./pages/v1/products/list.js";
import ProductVariant from "./pages/v1/products/variants/variants.js";
import ProductAddEditPage from "./pages/v1/products/AddEditData.js";
import OrdersDetails from "./pages/v1/promocodes/orderdetails.js";
import ProductDetails from "./pages/v1/products/productDetails.js";
import AddEditVariantData from "./pages/v1/products/variants/AddEditVariantsData.js";

// import InventoryList from './pages/v1/products/inventoryList.js';
// import AddEditInventoryData from "./pages/v1/products/AddEditInventoryData.js";

import InventoryList from "./pages/v1/products/Inventory/list.js";
import AddEditInventoryData from "./pages/v1/products/Inventory/AddEditData.js";

import OrderList from "./pages/v1/products/OrderList.js";
import OrderDetails from "./pages/v1/products/OrderDetails.js";
import CampaignList from "./pages/v1/campaign/campaignList.js";
import GeneralAddEditData from "./pages/v1/Cms/generalAddEdit.js";
import CampaignAddEdit from "./pages/v1/campaign/campaignAddEdit.js";
// import DrawDateTime from "./pages/v1/Cms/campaign/drawDateTime.js"
import PrizeAddEdit from "./pages/v1/campaign/prizeAddEdit.js";
import PrizeList from "./pages/v1/campaign/prizeList.js";
import SettingAddEdit from "./pages/v1/campaign/settingAddEdit.js";
import CampaignOrderList from "./pages/v1/campaign/orderList.js";

import RaffleWinners from "./pages/v1/raffleWinners/List.js";
import RaffleWinnersAddEdit from "./pages/v1/raffleWinners/AddEditData.js";

import BannerList from "./pages/v1/Cms/Banner/list.js";
import CampaignOrderDetails from "./pages/v1/campaign/campaignOrderDetails.js";
import BannerAddEditData from "./pages/v1/Cms/Banner/addEdit.js";
import Freezes from "./pages/v1/campaign/freezes.js";

// import { useUserStore } from "./lib/userStore.js";
import LottoWinnerList from "./pages/v1/lottoWinners/List.js";
import LottoWinnerDetailedList from "./pages/v1/lottoWinners/DetailedList.js";
import LottoWinnerRedeemedList from "./pages/v1/lottoWinners/redeemed/List.js";
import WinnerAnalyser from "./pages/v1/lottoWinners/analyser/list.js"


import RaffleDrawList from "./pages/v1/raffleDraw/list.js";
import RaffleDrawAddEdit from "./pages/v1/raffleDraw/addEditDataRaffleDraw.js";

import WalletStatementList from "./pages/v1/walletstatement/List.js";
import ActiveLogs from "./pages/v1/activelogs/List.js";

//Invice
import InvoiceList from "./pages/v1/invoice/individual/List.js";
import InvoiceAddEdit from "./pages/v1/invoice/individual/AddEditData.js";
import PreviewInvoice from "./pages/v1/invoice/preview.js";

import BulkInvoiceList from "./pages/v1/invoice/bulk/List.js";
import BulkCreateRequest from "./pages/v1/invoice/bulk/CreateRequest.js";
import BulkRequestList from "./pages/v1/invoice/bulk/RetailersList.js";
import BulkPreview from "./pages/v1/invoice/bulk/BulkPreview.js";
import BulkDownload from "./pages/v1/invoice/bulk/DownloadInvoice.jsx"
//End

import StatisticsReports from "./pages/v1/statisticsReports/List.js";

import PickPointsList from "./pages/v1/Cms/pickuppoints/list.js"
import PickupPointAddEdit from  "./pages/v1/Cms/pickuppoints/addEdit.js";

const App = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // const { fetchUserInfo } = useUserStore();
  const user = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));

  const getIp = async () => {
    await fetchIpAddress();
  };

  useEffect(() => {
    const checkAuthentication = async () => {
      await getIp();
      const token = sessionStorage.getItem("TOKEN");

      if (
        !["/", "/login", "/reset-password", "/invoice/preview"].includes(
          location?.pathname
        )
      ) {
        if (!token) {
          navigate("/");
        } else {
          // fetchUserInfo();
        }
      }
    };

    checkAuthentication();
  }, [location, navigate]);

  const [PERMISSIONDATA, setPermissionData] = useState("");
  const handlePermission = async () => {
    const encrypted = JSON.parse(sessionStorage.getItem("ADMIN-PERMISSION"));
    const decrypted = await decryptData(encrypted);
    const permission = JSON.parse(decrypted);
    setPermissionData(permission);
  };

  useEffect(() => {
    const userData = JSON.parse(sessionStorage.getItem("ADMIN-INFO"));
    if (
      userData &&
      sessionStorage.getItem("ADMIN-PERMISSION") !== "undefined" &&
      userData?.admin_type !== "Super Admin"
    ) {
      handlePermission();
    }
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route
          path="/dashboard"
          element={
            <Sidebar>
              <PermissionProvider>
                <Dashboard />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {user?.admin_type === "Super Admin" && (
          <>
            <Route
              path="/sub-admin/list"
              element={
                <Sidebar>
                  <PermissionProvider>
                    <SubAdminList />
                  </PermissionProvider>
                </Sidebar>
              }
            />
          </>
        )}

        <Route
          path="/sub-admin/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <SubAdminAddEditData />
              </PermissionProvider>
            </Sidebar>
          }
        />

        {/* product */}
        <Route
          path="/product/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <ProductList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <ProductAddEditPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product_details"
          element={
            <Sidebar>
              <PermissionProvider>
                <ProductDetails />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product/variants/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <ProductVariant />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product/variants/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <AddEditVariantData />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product/inventory/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <InventoryList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product/inventory/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <AddEditInventoryData />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product/order/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <OrderList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/product/order/details"
          element={
            <Sidebar>
              <PermissionProvider>
                <OrderDetails />
              </PermissionProvider>
            </Sidebar>
          }
        />

        {/* promocodes */}
        <Route
          path="/promocodes/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <PromocodeList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/promocodes/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <PromocodeEditPage />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/promocodes/order"
          element={
            <Sidebar>
              <PermissionProvider>
                <PromocodeOrder />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/promocodes/orderDetails"
          element={
            <Sidebar>
              <PermissionProvider>
                <OrdersDetails />
              </PermissionProvider>
            </Sidebar>
          }
        />

        <Route
          path="/promocodes/vouchers/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <PromoCodeVoucher />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* end procodes */}
        <Route
          path="/users/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <UsersList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/users/B2B-user-list"
          element={
            <Sidebar>
              <PermissionProvider>
                <B2BUserList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/users/B2C-user-list"
          element={
            <Sidebar>
              <PermissionProvider>
                <B2CUserList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/users/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <UsersAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/recharge/b-point-list"
          element={
            <Sidebar>
              <PermissionProvider>
                <BPointList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}

        {/* cms */}
        <Route
          path="/cms/general_data/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <GeneralAddEditData />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/cms/pickup-point/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <PickPointsList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/cms/pickup-point/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <PickupPointAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/campaign/prize/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <PrizeAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/campaign/prize/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <PrizeList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/campaign/setting/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <SettingAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/campaign/order/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <CampaignOrderList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/campaign/order/details"
          element={
            <Sidebar>
              <PermissionProvider>
                <CampaignOrderDetails />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/campaign/freezes"
          element={
            <Sidebar>
              <PermissionProvider>
                <Freezes />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}

        <Route
          path="/campaign/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <CampaignList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/campaign/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <CampaignAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* cms */}

        <Route
          path="/cms/general_data/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <GeneralAddEditData />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/cms/banner/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <BannerList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/cms/banner/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <BannerAddEditData />
              </PermissionProvider>
            </Sidebar>
          }
        />

        {/* End */}
        {/* Raffle Winners */}
        <Route
          path="/raffle-winners/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <RaffleWinners />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/raffle-winners/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <RaffleWinnersAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}

        {/* raffle draw  */}
        <Route
          path="/raffle-draw/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <RaffleDrawList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/raffle-draw/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <RaffleDrawAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}

        {/* Lotto Winners */}
        <Route
          path="/lotto-winners/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <LottoWinnerList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/lotto-winners/detailed-list"
          element={
            <Sidebar>
              <PermissionProvider>
                <LottoWinnerDetailedList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/lotto-winners/redeem-list"
          element={
            <Sidebar>
              <PermissionProvider>
                <LottoWinnerRedeemedList />
              </PermissionProvider>
            </Sidebar>
          }
        />

        <Route
          path="/lotto-winners/analyser"
          element={
            <Sidebar>
              <PermissionProvider>
                <WinnerAnalyser />
              </PermissionProvider>
            </Sidebar>
          }
        />

        {/* End */}

        {/* Lotto Winners */}
        <Route
          path="/wallets-statement/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <WalletStatementList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}

        {/* Active Logs */}
        <Route
          path="/active-logs"
          element={
            <Sidebar>
              <PermissionProvider>
                <ActiveLogs />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}

        {/* Invoice*/}
        <Route
          path="/invoice/list"
          element={
            <Sidebar>
              <PermissionProvider>
                <InvoiceList />
              </PermissionProvider>
            </Sidebar>
          }
        />

        <Route
          path="/invoice/addeditdata"
          element={
            <Sidebar>
              <PermissionProvider>
                <InvoiceAddEdit />
              </PermissionProvider>
            </Sidebar>
          }
        />

        <Route
          path="/invoice/preview"
          element={
            <PermissionProvider>
              <PreviewInvoice />
            </PermissionProvider>
          }
        />
        
        <Route
          path="/invoice/bulk-list"
          element={
            <Sidebar>
              <PermissionProvider>
                <BulkInvoiceList />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/invoice/create-request"
          element={
            <Sidebar>
              <PermissionProvider>
                <BulkCreateRequest />
              </PermissionProvider>
            </Sidebar>
          }
        />
        <Route
          path="/invoice/retailers-list/:batch_id"
          element={
            <Sidebar>
              <PermissionProvider>
                <BulkRequestList />
              </PermissionProvider>
            </Sidebar>
          }
        />

        <Route
          path="/invoice/bulk-preview/:batch_id"
          element={
            <Sidebar>
              <PermissionProvider>
                <BulkPreview />
              </PermissionProvider>
            </Sidebar>
          }
        />

        <Route
          path="/invoice/bulk/download-all"
          element={
            <Sidebar>
              <PermissionProvider>
                <BulkDownload />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* End */}
        {/* Statistics Reports */}
        <Route
          path="/statistics-reports"
          element={
            <Sidebar>
              <PermissionProvider>
                <StatisticsReports />
              </PermissionProvider>
            </Sidebar>
          }
        />
        {/* END */}
      </Routes>
    </div>
  );
};

export default App;
